<template>
  <div>
      <home-page></home-page>
      <lxm-dialog></lxm-dialog>
  </div>
</template>

<script>
  /* global $: false */
  import LxmDialog from './common/LxmDialog.vue'
  import * as aTypes from '../store/action-types'
  import * as mTypes from '../store/mutation-types'
  import HomePage from '@/components/Main/Home'
  export default {
    components: {
      HomePage,
      LxmDialog
    },
    methods: {
      initWechatJs () {
        if (this.$store.state.wechatJsReady) {
          return
        }
        const url = window.location.href.split('#')[0]
        this.$store.dispatch(aTypes.FETCH_WECHAT_JS_CONFIG, { url })
          .then(res => {
            const config = res.body
            config.jsApiList = ['scanQRCode']
            this.$wx.config(config)
            this.$wx.ready(() => {
              this.$store.commit(mTypes.SET_WECHAT_JS_READY, { ready: true })
            })
            this.$wx.error(err => {
              if (err) {
                this.$store.commit(mTypes.SET_WECHAT_JS_READY, { ready: false })
                throw new Error(err)
              }
            })
          })
          .catch(err => {
            throw new Error(err)
          })
      }
    },
    created () {
      console.log('app created...', this.$store.state.wechatJsReady)
      if (window.X.env.is_wechat) {
        this.initWechatJs()
      }
    },
    mounted () {
      console.log('app mounted...', this.$store.state.wechatJsReady)
      if (this.$route.path === '/') {
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.replace('auth').catch(err => {
          console.error(err)
        })
      }
      $('html').css('font-size', `${document.body.clientWidth / 375 * 14}px`)
      this.$store.dispatch(aTypes.LOGIN_GET_SMS_LEFT_TIME)
      // if (window.X.env.is_wechat) {
      //   this.initWechatJs()
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?3b7cfd7e